import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './RadioButton.module.scss.js';

function RadioButton(_ref) {
  var isChecked = _ref.isChecked,
    disabled = _ref.disabled,
    id = _ref.id,
    title = _ref.title,
    _onChange = _ref.onChange,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    htmlFor: id,
    className: classNames(styles.container, disabled && styles.disabled, className)
  }, /*#__PURE__*/React.createElement("p", {
    className: styles.text
  }, title), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: classNames(styles.radioBtn, isChecked && styles.checked, disabled && styles.disabled),
    onClick: function onClick(e) {
      if (!disabled && !isChecked) {
        _onChange(e);
      }
    }
  }), /*#__PURE__*/React.createElement("input", {
    id: id,
    type: "radio",
    onChange: function onChange(e) {
      if (!disabled && !isChecked) {
        _onChange(e);
      }
    },
    checked: isChecked,
    name: "radio",
    disabled: disabled
  }));
}
RadioButton.propTypes = {
  isChecked: PropTypes.bool,
  disabled: PropTypes.bool,
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  onChange: PropTypes.func,
  className: PropTypes.string
};
RadioButton.defaultProps = {
  isChecked: false,
  disabled: false,
  title: '',
  onChange: function onChange() {},
  className: ''
};

export { RadioButton as default };
